import { makeStyles, Grid, FormControl, InputLabel, Select, MenuItem, FormHelperText, TextField, Divider, Button, createStyles, Theme, Modal, CircularProgress, FormLabel, FormControlLabel, Radio, RadioGroup, IconButton } from "@material-ui/core";
import React, { useEffect } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { searchFanAsync, getFanBusy, resetFanStore, getAllFansData } from "../../app/reducer/fan.reducer";
import { createNewProject, getFanDetails, getFanData, getFetchingError, getFetching, getHasFan, getProjectState, getProjectDetails, updateFanDetails, getDrafts, getProjects, createNewDraft, getGADetails } from "../../app/reducer/project.reducer";

import { FanDetailsFormInput, rotorTypeArr, applicationArr, installationTypeArr, mountingOrientationArr, inletTypeArr, beamNoArr, LDArr, motorClassificationArr, hubTypeArr, hubPlateMaterialArr, clampMaterialArr, bushMaterialArr, hardwareMaterialArr, curveSrcArr, driveTypeArr, bladeMaterialArr } from "../../app/utils/formData";
import AlertComponent from "../general/Alert";
import SelectFanPopUp from "../popups/SelectFanPopUp";
import { fixedDiameters, noOfBlade } from "../../utils/constants"
import { useHelp } from "../../utils/HelpContext";
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from "../tooltip/Tooltip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getAllFans } from "../../app/api/fan";
import { getUser } from "../../app/reducer/auth.reducer";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    formControl: {
      width: '100%',
    },
    radioWrapped: {
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    redOutline: {
      borderColor: "red !important"
    }
  }),
);


export default function FanDetailsForm({ setIndex }: { setIndex: Function }): JSX.Element {
  const [busy, setBusy] = React.useState<boolean>(false);
  const [dirty, setDirty] = React.useState<boolean>(false);

  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);
  const [openFanSelectionPopUp, setOpenFanSelectionPopUp] = React.useState<boolean>(false);
  const [fanDiametersList,setFanDiameterList] = React.useState<number[]>([]);
  const [showAdditionalDetails, setShowAdditionalDetails] = React.useState(true);
  const [fanBladeList,setFanbladeList] = React.useState<number[]>([]);
  const { register, handleSubmit, setValue, control, formState: { errors } } = useForm<FanDetailsFormInput>();
  const dispatch = useDispatch()
  const classes = useStyles();

  const history = useHistory();

  const projectState = useAppSelector(getProjectState);
  const hasFan = useAppSelector(getHasFan);
  const projectDetails = useAppSelector(getProjectDetails);
  const fanDetails = useAppSelector(getFanDetails);
  const gaDetails = useAppSelector(getGADetails);
  const fanBusy = useAppSelector(getFanBusy);
  const fan = useAppSelector(getFanData);
  const projBusy = useAppSelector(getFetching);
  const fetchingErr = useAppSelector(getFetchingError);
  const user = useAppSelector(getUser);

    const { help } = useHelp(); // Access the help toggle state
    const [activeTooltip, setActiveTooltip] = React.useState<string | null>(null); // Track which tooltip is active
  
    // Define a type for helpData keys
    type HelpDataKeys = 'RotorType' | 'FanDia'|'NoBlade'|'FanSpeed';
    
    // Define helpData with the possible keys
    const helpData: Record<HelpDataKeys, string> = {
      RotorType: "This is a saved project that is intended to be used later in the project",
      FanDia: "List of all the projects running currently3",
      NoBlade: "List of all the projects running currently23",
      FanSpeed:"List of all the projects running currently2"
    };
  
    // Handle tooltip visibility when clicking the "?" button
    const handleTooltipClick = (fieldId: string) => {
      console.log("Clicked field:", fieldId); // Debugging: check which field is clicked
      setActiveTooltip((prev) => (prev === fieldId ? null : fieldId)); // Toggle tooltip visibility
    };

  const { unit ="SI" } = projectDetails||{};
  console.log(projectDetails)
  useEffect(() => {
    console.log("fanDetialsform", fanDetails, "fanDetailsForm:fan", fan);

    if (fanDetails) {
      for (const [key, value] of Object.entries(fanDetails)) {
        setValue(key as any, value);
        console.log(key,typeof(value));
      }
    }
    setShowAdditionalDetails(false); // it helps in closing the menu after all the field values are set
    // if(user.user?.userType==3 || user.user?.userType==3 )
    // {
    //   setValue('curve_src','Legacy')
    // }
    // if(fan && (fanDetails?.fan_speed==undefined || fanDetails?.fan_speed==''))
    // {
    //   setValue('fan_speed',fan?.rpm)
    //   console.log(fan?.rpm)
    // }
  }, [fanDetails, setValue])

  useEffect(() => {
    if (hasFan && dirty) {
      setOpenAlert(true)
      setDirty(false);
    }
  }, [hasFan])


    useEffect(() => {
      const fetchDiaAndBladeNumber=async ()=>{
        const res = await getAllFans()
        console.log(res);
        const diaList= res.response.data.map((e:any)=>e.fanDiameter)
        const bladeList= res.response.data.map((e:any)=>e.numofBlades)
        const uniqueArrDia = diaList.filter((item:any, index:any) => diaList.indexOf(item) === index);
        const uniqueArrBlade = bladeList.filter((item:any, index:any) => bladeList.indexOf(item) === index);
        setFanDiameterList(uniqueArrDia);
        setFanbladeList(uniqueArrBlade)
      }
      fetchDiaAndBladeNumber();
  }, [])

  const createDraft = async () => {
    console.log('saveDraft')
    let data = { ...projectDetails, fan_form: fanDetails, fan_details: fan };
    if (gaDetails) {
      data.ga_details = gaDetails;
    }
    await dispatch(createNewDraft(data));

    //if (fetchingErr === false) {
    dispatch(getDrafts());
    dispatch(getProjects());
    dispatch(resetFanStore());
    //   history.push('/projects');
    // } else {
    //   setOpenErrAlert(true)
    // }

  }

  const saveProjectFromForm: SubmitHandler<FanDetailsFormInput> = async (formData) => {
    // 1) Persist the latest form values into redux
    await dispatch(updateFanDetails(formData));
    console.log(formData)
    // 2) Use the same formData (not stale fanDetails) to build payload
    const payload: any = {
      ...projectDetails,
      fan_form: formData,
      fan_details: fan,
    };

    if (gaDetails) payload.ga_details = gaDetails;

    await dispatch(createNewProject(payload));

    if (fetchingErr === false) {
      dispatch(getDrafts());
      dispatch(getProjects());
      dispatch(resetFanStore());
      history.push("/projects");
    } else {
      setOpenErrAlert(true);
    }
  };

  const onSubmit: SubmitHandler<FanDetailsFormInput> = async data => {
    setBusy(true);
    setDirty(true);

    let searchData = data;
    console.log("search data", data)
    if (projectState == "new" && !searchData.lnd) searchData.lnd = 0.1

    if (!data.barometric_pressure) {
      // alert("AIR DENSITY")
      const { altitude, inlet_temp } = data;
      const exponent = ((-9.80665 * 0.028964 * (altitude - 0)) / (8.31432 * ((inlet_temp - 0) + 273)));
      const calculatedBarometricPressure = 101325 * Math.exp(parseFloat(exponent.toFixed(10)));
      searchData.barometric_pressure = calculatedBarometricPressure;
      setValue('barometric_pressure', calculatedBarometricPressure);
    }

    if (!data.air_density) {
      // alert("AIR DENSITY")
      const { inlet_temp, altitude, rh } = data;
      // const e = inlet_temp+273;
      // const d = barometric_pressure;
      // const c = 6.1078*(10^((7.5*inlet_temp)/(inlet_temp+237.3)));
      // const b = c * rh;
      // const a = d - b;
      const calculatedDensity = (((101325 * Math.exp((-9.80665 * 0.028964 * (altitude - 0)) / (8.31432 * ((inlet_temp - 0) + 273)))) - ((6.1078 * (10 ^ ((7.5 * (inlet_temp - 0)) / ((inlet_temp - 0) + 237.3)))) * (rh - 0))) / (287.058 * ((inlet_temp - 0) + 273))) + (((6.1078 * (10 ^ ((7.5 * (inlet_temp - 0)) / ((inlet_temp - 0) + 237.3)))) * (rh - 0)) / (461.495 * ((inlet_temp - 0) + 273)))
      searchData.air_density = parseFloat(calculatedDensity.toFixed(3));
      setValue('air_density', parseFloat(calculatedDensity.toFixed(3)));
    }

    // if(!data.fan_ring_diameter){
    //   // alert("AIR DENSITY")
    //   const { fan_diameter } = data;
    //   if(fan_diameter){
    //     const calculatedFanRingDiameter = fan_diameter * 1.05;
    //     searchData.fan_ring_diameter = calculatedFanRingDiameter;
    //     setValue('fan_ring_diameter', calculatedFanRingDiameter );
    //   }

    // }

    if (data.curve_src === "All") {
      searchData.curve_src = '';
    }

    // if(!data.diffuser_eff){
    //   // alert("AIR DENSITY")
    //   const { fan_diameter } = data;
    //   if(fan_diameter){
    //     const calculatedFanRingDiameter = fan_diameter * 1.05;
    //     searchData.fan_ring_diameter = calculatedFanRingDiameter;
    //     setValue('fan_ring_diameter', calculatedFanRingDiameter );
    //   }

    // }

    // if(!data.discharge_dia){
    //   // alert("AIR DENSITY")
    //   const { fan_diameter } = data;
    //   if(fan_diameter){
    //     const calculatedFanRingDiameter = fan_diameter * 1.05;
    //     searchData.fan_ring_diameter = calculatedFanRingDiameter;
    //     setValue('fan_ring_diameter', calculatedFanRingDiameter );
    //   }

    // }

    await dispatch(updateFanDetails(data));


    // if(data.fan_ring_diameter===null){
    //   searchData.fan_ring_diameter = (data.fan_diameter*1.05)/
    // }

    await dispatch(searchFanAsync(searchData));
    setBusy(false);
    setOpenFanSelectionPopUp(true);
    // console.log("FAN", data);
    // alert(data);
  };

  const saveDraft = async (data: FanDetailsFormInput) => {
    setBusy(true);
    await dispatch(updateFanDetails(data));
    setBusy(false);
  }

  const unitValue = "SI";
  const generateOptions = () => {
    const options = [];
    for (let i = 800; i <= 13000; i += 100) {
      options.push(i / (unit === 'SI' ? 1000 : 25.4)); // Adjust value based on unit
    }
    return options;
  };

  return (
    <form id="fan-details-form" onSubmit={handleSubmit(onSubmit)} style={{ padding: '5px' }}>
      <Grid container spacing={3}>

        <Grid item xs={12} lg={3}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.rotor_type ? true : false}>
            <InputLabel style={{fontSize:'20px'}} >Rotor Type</InputLabel>
            <Controller
              control={control}
              name="rotor_type"
              defaultValue="axial"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Rotor Type"
                  style={{fontSize:'20px'}} 
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {rotorTypeArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}}   key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
             {help && (
                  <IconButton
                    type="button"
                    onClick={() => handleTooltipClick('RotorType')}
                    color="primary" 
                    style={{ padding: '0px' }}
                  >
                    <HelpIcon />
                  </IconButton>
                )}
                {/* Ensure the Tooltip receives a string from helpData safely */}
                <Tooltip text={helpData['RotorType' as HelpDataKeys]} isVisible={activeTooltip === 'RotorType'} />
            
            <FormHelperText>{errors.rotor_type ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={3}>
          {/* <TextField
            label={"Fan Diameter " + (unit === "SI" ? "(Metre)" : "(Inch)")} disabled={projectState !== "new"}
            {...register("fan_diameter")}
            variant="outlined" fullWidth
            error={(errors.fan_diameter ? true : false)}
            helperText={errors.fan_diameter ? 'This field is required' : ''}
          /> */}

                  <FormControl
          variant="outlined"
          className={classes.formControl}
          error={!!errors.fan_diameter}
        >
          <Controller
            control={control}
            name="fan_diameter"

            render={({ field: { onChange, value } }) => (
              <Autocomplete
                freeSolo
                options={fanDiametersList
                  .sort((a, b) => a - b)
                  .map((d) => d.toFixed(3))} // convert to string here
                disabled={projectState !== "new"}
                onChange={(e, newValue) => {
                  onChange(newValue || "");
                }}
                onInputChange={(e, newInputValue) => {
                  onChange(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Fan Diameter (Meters)"
                    variant="outlined"
                    error={!!errors.fan_diameter}
                    helperText={
                      errors.fan_diameter ? "This field is required" : ""
                    }
                    InputLabelProps={{
                      style: { fontSize: "18px" },
                    }}
                  />
                )}
              />
            )}
          />
        </FormControl>


        </Grid>
        <Grid item xs={12} lg={3}>
          {/* <TextField
            label="No of Blades" disabled={projectState !== "new"}
            {...register("blade_no")}
            variant="outlined" fullWidth
            error={(errors.blade_no ? true : false)}
            helperText={errors.blade_no ? 'This field is required' : ''}
          /> */}

          <FormControl variant="outlined" className={classes.formControl} error={errors.install_type ? true : false}>
            <InputLabel style={{fontSize:'20px'}} >No of Blades</InputLabel>
            <Controller
              control={control}
              name="blade_no"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  disabled={projectState !== "new"}
                  onChange={onChange}
                  label="No of Blades"
                  style={{fontSize:'20px'}} 
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {fanBladeList.sort((a, b) => a - b).map((option, index) => (
                    <MenuItem style={{fontSize:'20px'}}  key={index} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            <FormHelperText>{errors.blade_no ? 'This field is required' : ''}</FormHelperText>
          </FormControl>

        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            label="Fan Speed (RPM)" disabled={projectState !== "new"}
            {...register("fan_speed")}
            variant="outlined" fullWidth
            error={(errors.fan_speed ? true : false)}
            helperText={errors.fan_speed ? 'This field is required' : ''}
            InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>

        <Grid item xs={12}>
        </Grid>

        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.application ? true : false}>
            <InputLabel style={{fontSize:'20px'}} >Application</InputLabel>
            <Controller
              control={control}
              name="application"
              defaultValue="cooling_tower"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Application"
                  style={{fontSize:'20px'}} 
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {applicationArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}}  key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.application ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.install_type ? true : false}>
            <InputLabel style={{fontSize:'20px'}}  >Installation Type</InputLabel>
            <Controller
              control={control}
              name="install_type"
              defaultValue="induced"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Installation Type"
                  style={{fontSize:'20px'}} 
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {installationTypeArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}}  key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.application ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.mounting_orientation ? true : false}>
            <InputLabel style={{fontSize:'20px'}} >Mounting Orientation</InputLabel>
            <Controller
              control={control}
              name="mounting_orientation"
              defaultValue="horizontal-clock"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Mounting Orientation"
                  style={{fontSize:'20px'}} 
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {mountingOrientationArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}}  key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.mounting_orientation ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>


        <Grid item xs={12} lg={4}>
          <TextField
            InputLabelProps={{ shrink: true, style: { fontSize: "18px" } }}
            label="Air Density (kg/m3)" disabled={projectState !== "new"}
            {...register("air_density")}
            variant="outlined" fullWidth
            defaultValue={1.2}
            error={(errors.air_density ? true : false)}
            helperText={errors.air_density ? 'This field is required' : ''}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="RH% (%)" defaultValue={60} disabled={projectState !== "new"}
            {...register("rh", { required: true })}
            variant="outlined" fullWidth
            error={(errors.rh ? true : false)}
            helperText={errors.rh ? 'This field is required' : ''}
            InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="Inlet Temperature (°C)" defaultValue={20} disabled={projectState !== "new"}
            {...register("inlet_temp", { required: true })}
            variant="outlined" fullWidth
            error={(errors.inlet_temp ? true : false)}
            helperText={errors.inlet_temp ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>


        <Grid item xs={12} lg={4}>
          <TextField
            label="Minimum (°C)" disabled={projectState !== "new"}
            {...register("minimum")}
            variant="outlined" fullWidth
            defaultValue={5}
            error={(errors.minimum ? true : false)}
            helperText={errors.minimum ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="Maximum (°C)" disabled={projectState !== "new"}
            {...register("maximum")}
            variant="outlined" fullWidth
            defaultValue={60}
            error={(errors.maximum ? true : false)}
            helperText={errors.maximum ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label={"Altitude " + (unit === "SI" ? "(Metres)" : "(Feet)")} defaultValue={0} disabled={projectState !== "new"}
            {...register("altitude", { required: true })}
            variant="outlined" fullWidth
            error={(errors.altitude ? true : false)}
            helperText={errors.altitude ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>


        <Grid item xs={12}>
        </Grid>


        <Grid item xs={12} lg={4}>
          <TextField
            label={"* Required Airflow" + (unit === "SI" ? "(m3/s)" : "(cfm)")} disabled={projectState !== "new"}
            {...register("req_airflow", { required: true })}
            variant="outlined" fullWidth
            error={(errors.req_airflow ? true : false)}
            helperText={errors.req_airflow ? 'This field is required' : ''}
            InputProps={{
              classes: {
                notchedOutline: classes.redOutline
              },
              style:{fontSize:'18px'}
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label={"* Pressure" + (unit === "SI" ? "(Pa)" : "(mmWC)")} disabled={projectState !== "new"}
            {...register("pressure", { required: true })}
            variant="outlined" fullWidth
            error={(errors.pressure ? true : false)}
            helperText={errors.pressure ? 'This field is required' : ''}
            InputProps={{
              classes: {
                notchedOutline: classes.redOutline
              },
              style:{fontSize:'18px'}
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl component="fieldset" error={errors.pressure_type ? true : false} className={classes.radioWrapped}>
            <FormLabel component="legend" style={{fontSize:'20px'}} >Pressure Type</FormLabel>
            <Controller
              control={control}
              name="pressure_type" rules={{ required: true }}
              defaultValue="total"
              render={({ field: { onChange, value } }) => (
                <RadioGroup aria-label="pressure_type" name="pressure_type" value={value} onChange={onChange} className={classes.radioGroup}>
                  <FormControlLabel value="total" control={<Radio disabled={projectState !== "new"} />} label="Total" />
                  <FormControlLabel value="static" control={<Radio disabled={projectState !== "new"} />} label="Static" />
                </RadioGroup>
              )}
            />
            <FormHelperText>{errors.pressure_type ? 'Please specify pressure type' : ''}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
        <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowAdditionalDetails((prev) => !prev)}
          >
            {showAdditionalDetails ? "Hide Additional Details" : "Additional Details"}
          </Button>
        </div>
      </Grid>

      {showAdditionalDetails && (
           <>   
        <Grid item xs={12} lg={4}>
          <TextField
            label="Tip Speed Limit (m/s)" defaultValue={60} disabled={projectState !== "new"}
            {...register("tips_speed_limit", { required: true })}
            variant="outlined" fullWidth
            error={(errors.tips_speed_limit ? true : false)}
            helperText={errors.tips_speed_limit ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.inlet_type ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Inlet type</InputLabel>
            <Controller
              control={control}
              name="inlet_type" rules={{ required: true }}
              defaultValue="circular"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Inlet type"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {inletTypeArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.inlet_type ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.beam_no ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Beam No</InputLabel>
            <Controller
                control={control}
                name="beam_no"
                rules={{ required: true, min: 1 }}
                defaultValue={4}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    type="number"
                    value={value}
                    disabled={projectState !== "new"}
                    onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
                    label="Beam No"
                    inputProps={{ min: 1, step: 1, style: { fontSize: "20px" } }}
                    InputLabelProps={{ style: { fontSize: "20px" } }}
                  />
                )}
              />
            <FormHelperText>{errors.beam_no ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>


        <Grid item xs={12} lg={4}>
          <TextField
            label="Venturi Height" defaultValue={0} disabled={projectState !== "new"}
            {...register("venturi_height", { required: true })}
            variant="outlined" fullWidth
            error={(errors.venturi_height ? true : false)}
            helperText={errors.venturi_height ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="Angle" defaultValue={45} disabled={projectState !== "new"}
            {...register("angle", { required: true })}
            variant="outlined" fullWidth
            error={(errors.angle ? true : false)}
            helperText={errors.angle ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.lnd ? true : false}>
            <InputLabel style={{fontSize:'20px'}}><em>*</em> L/D</InputLabel>
            <Controller
              control={control}
              name="lnd"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  defaultValue={0.1}
                  label="L/D"
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {LDArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.lnd ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>


        <Grid item xs={12}>
        </Grid>


        <Grid item xs={12} lg={6}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.motor_classification ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Motor Classification</InputLabel>
            <Controller
              control={control}
              name="motor_classification"
              defaultValue="ie2" rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Motor Classification"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {motorClassificationArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.motor_classification ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            label="Motor Efficiency" defaultValue={94} disabled={projectState !== "new"}
            {...register("motor_eff", { required: true })}
            variant="outlined" fullWidth
            error={(errors.motor_eff ? true : false)}
            helperText={errors.motor_eff ? 'This field is required' : ''}
            InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>


        <Grid item xs={12} lg={6}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.hub_type ? true : false}>
            <InputLabel style={{fontSize:'20px'}} >Hub type</InputLabel>
            <Controller
              control={control}
              name="hub_type"
              defaultValue="single_plate_fenner"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Hub type"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {hubTypeArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.hub_type ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.hub_plate_material ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Hub Plate Material</InputLabel>
            <Controller
              control={control}
              name="hub_plate_material"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Hub Plate Material"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {hubPlateMaterialArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.hub_plate_material ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>


        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.clamp_material ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Clamp Material</InputLabel>
            <Controller
              control={control}
              name="clamp_material"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Clamp Material"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {clampMaterialArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.clamp_material ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.bush_material ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Hub Spool</InputLabel>
            <Controller
              control={control}
              name="bush_material"
              defaultValue="ie1"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Hub Spool"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {bushMaterialArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.bush_material ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.hardware_material ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Hardware Material</InputLabel>
            <Controller
              control={control}
              name="hardware_material"
              render={({ field: { onChange, value } }) => (
                <Select disabled={projectState !== "new"}
                  value={value}
                  onChange={onChange}
                  label="Hardware Material"
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {hardwareMaterialArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.hardware_material ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>


        <Grid item xs={12}>
        </Grid>


        <Grid item xs={12} lg={3}>
          <TextField
            InputLabelProps={{ shrink: true,style: { fontSize: "18px" } }}
            label="Fan Ring Diameter (Metre)" disabled={projectState !== "new"}
            {...register("fan_ring_diameter")}
            variant="outlined" fullWidth
            error={(errors.fan_ring_diameter ? true : false)}
            helperText={errors.fan_ring_diameter ? 'This field is required' : ''}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            label="No of Sets" disabled={projectState !== "new"}
            {...register("set_no")}
            variant="outlined" fullWidth
            error={(errors.set_no ? true : false)}
            helperText={errors.set_no ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.atmosphere_type ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Atmosphere Type</InputLabel>
            <Controller
            
              control={control}
              name="atmosphere_type"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState === "new"}
                  onChange={onChange}
                  label="Atmosphere Type"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {hardwareMaterialArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.atmosphere_type ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            InputLabelProps={{ shrink: true,style: { fontSize: "18px" } }}
            label="Barometric Pressure (Pa)" disabled={projectState !== "new"}
            {...register("barometric_pressure")}
            variant="outlined" fullWidth
            error={(errors.barometric_pressure ? true : false)}
            helperText={errors.barometric_pressure ? 'This field is required' : ''}
          />
        </Grid>


        <Grid item xs={12} lg={3}>
          <TextField
            label="Diffuser Efficiency (%)" disabled={projectState !== "new"}
            {...register("diffuser_eff")}
            variant="outlined" fullWidth
            error={(errors.diffuser_eff ? true : false)}
            helperText={errors.diffuser_eff ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.ga_drawing_id ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>GA Drawing id</InputLabel>
            <Controller
              control={control}
              name="ga_drawing_id"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState == "new"}
                  onChange={onChange}
                  label="GA Drawing id"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {hardwareMaterialArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.ga_drawing_id ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            label="Discharge Diameter (meter)" disabled={projectState !== "new"}
            {...register("discharge_dia")}
            variant="outlined" fullWidth
            error={(errors.discharge_dia ? true : false)}
            helperText={errors.discharge_dia ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            label="Transmission Efficiency (%)" disabled={projectState !== "new"}
            {...register("transmission_eff")}
            variant="outlined" fullWidth defaultValue={94}
            error={(errors.transmission_eff ? true : false)}
            helperText={errors.transmission_eff ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>


        {/* <Grid item xs={12} lg={3}>
          <TextField
            label="Hub Bore Diameter (mm)" disabled={projectState !== "new"}
            {...register("hub_diameter")}
            variant="outlined" fullWidth
            error={(errors.hub_diameter ? true : false)}
            helperText={errors.hub_diameter ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid> */}
        <Grid item xs={12} lg={3}>
          <TextField
            label="Motor Rating (kW)" disabled={projectState !== "new"}
            {...register("motor_rating")}
            variant="outlined" fullWidth
            error={(errors.motor_rating ? true : false)}
            helperText={errors.motor_rating ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            label="Motor RPM" disabled={projectState !== "new"}
            {...register("motor_rpm")}
            variant="outlined" fullWidth
            error={(errors.motor_rpm ? true : false)}
            helperText={errors.motor_rpm ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        {/* <Grid item xs={12} lg={3}>
          <TextField
            label="Fan RPM" disabled={projectState !== "new"}
            {...register("fan_rpm")}
            variant="outlined" fullWidth
            error={(errors.fan_rpm ? true : false)}
            helperText={errors.fan_rpm ? 'This field is required' : ''}
          />
        </Grid> */}


        <Grid item xs={12} lg={3}>
          <TextField
            label="Sound Power Correction Factor (dB)" defaultValue={3}
            {...register("sound_power_cf", { required: true })}
            variant="outlined" fullWidth disabled={projectState !== "new"}
            error={(errors.sound_power_cf ? true : false)}
            helperText={errors.sound_power_cf ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            label="Continuous Unbalance Mass (kg)" defaultValue={0.05}
            {...register("cont_unbalance_mass", { required: true })}
            variant="outlined" fullWidth disabled={projectState !== "new"}
            error={(errors.cont_unbalance_mass ? true : false)}
            helperText={errors.cont_unbalance_mass ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            label="Blade Centre of Gravity Radius Ratio w.r.t Diameter" defaultValue={0.4}
            {...register("blade_cog_ratio", { required: true })}
            variant="outlined" fullWidth disabled={projectState !== "new"}
            error={(errors.blade_cog_ratio ? true : false)}
            helperText={errors.blade_cog_ratio ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <TextField
            label="Minimum Pressure Margin (%)" defaultValue={20}
            {...register("min_pressure_margin", { required: true })}
            variant="outlined" fullWidth disabled={projectState !== "new"}
            error={(errors.min_pressure_margin ? true : false)}
            helperText={errors.min_pressure_margin ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>


        <Grid item xs={12} lg={3}>
          <TextField
            label="Minimum Airflow Margin (%)" defaultValue={10}
            {...register("min_airflow_margin", { required: true })}
            variant="outlined" fullWidth disabled={projectState !== "new"}
            error={(errors.min_airflow_margin ? true : false)}
            helperText={errors.min_airflow_margin ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.curve_src ? true : false}>
            <InputLabel style={{fontSize:'20px'}}><em>*</em> Curve Source</InputLabel>
            <Controller
              control={control} defaultValue={(user?.user?.userType==3||user?.user?.userType==4)?'Legacy':'All'}
              name="curve_src" rules={{ required: false }}
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={e => {
                    onChange(e);
                    dispatch(updateFanDetails({ ...fanDetails, curve_src: e.target.value }));
                  }}
                  label="Curve Source"
                  style={{fontSize:'20px'}}
                >

                  {curveSrcArr.map(el => {

                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.curve_src ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={3}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.octave_band_id ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Octave Band ID</InputLabel>
            <Controller
              control={control}
              name="octave_band_id"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Octave Band ID"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {hardwareMaterialArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.octave_band_id ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            label="Blade Model" disabled={projectState !== "new"}
            {...register("blade_model")}
            variant="outlined" fullWidth
            error={(errors.blade_model ? true : false)}
            helperText={errors.blade_model ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>


        <Grid item xs={12} lg={6}>
          <TextField
            label="Hub ID" disabled={projectState !== "new"}
            {...register("hub_id")}
            variant="outlined" fullWidth
            error={(errors.hub_id ? true : false)}
            helperText={errors.hub_id ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>


        <Grid item xs={12} lg={3}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.drive_type ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Drive Type</InputLabel>
            <Controller
              control={control}
              name="drive_type"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Drive Type"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {driveTypeArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.drive_type ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} lg={3}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.blade_material ? true : false}>
            <InputLabel style={{fontSize:'20px'}}>Blade Material </InputLabel>
            <Controller
              control={control}
              name="blade_material"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Blade Material"
                  style={{fontSize:'20px'}}
                >
                  <MenuItem style={{fontSize:'20px'}} value="">
                    <em>None</em>
                  </MenuItem>
                  {bladeMaterialArr.map(el => {
                    return <MenuItem style={{fontSize:'20px'}} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.blade_material ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField
            label="Transmission Efficiency (%)" disabled={projectState !== "new"}
            {...register("transmission_efficiency")}
            variant="outlined" fullWidth defaultValue={94}
            error={(errors.transmission_efficiency ? true : false)}
            helperText={errors.transmission_efficiency ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField
            label="Hub Bore Diameter (mm)" disabled={projectState !== "new"}
            {...register("hub_bore_diameter")}
            variant="outlined" fullWidth
            error={(errors.hub_bore_diameter ? true : false)}
            helperText={errors.hub_bore_diameter ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField
            label="Keyway" disabled={projectState !== "new"}
            {...register("keyway")}
            variant="outlined" fullWidth
            error={(errors.keyway ? true : false)}
            helperText={errors.keyway ? 'This field is required' : ''}
             InputLabelProps={{
                style: { fontSize: "18px" }
              }}
          />
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        </>)}
        <Grid item xs={12} lg={12}>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            disabled={fanBusy}
          // onClick={e=>setIndex(2)}
          >
            {fanBusy ?
              <CircularProgress
                size={26}
              /> : "Search Fan"}
          </Button>


          {(projectState === "new" && hasFan === true) &&
            <Button
              variant="outlined"
              color="primary"
              size="large"
              disabled={busy}
              onClick={() => createDraft()}
              style={{ marginLeft: '20px' }}
            >
              {projBusy ?
                <CircularProgress
                  size={26}
                /> : "Create Draft"}
            </Button>
          }
          {(hasFan === true && projectState !== 'saved') &&
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSubmit(saveProjectFromForm)}
              style={{ marginLeft: '20px' }}
              disabled={projBusy}
            >
              {projBusy ?
                <CircularProgress
                  size={26}
                /> : "Save Project"}
            </Button>}

          {hasFan === true &&
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={e => setIndex(2)}
              style={{ marginLeft: '20px'}}
            >
              Next
            </Button>}
        </Grid>
      </Grid>
      <AlertComponent open={openAlert} message="Fan Selected for current Project." severity="success" handleClose={() => { setOpenAlert(false) }} />
      <AlertComponent open={openErrAlert} message="Something went wrong. Please Try again." severity="error" handleClose={() => { setOpenErrAlert(false) }} />
      <SelectFanPopUp open={openFanSelectionPopUp} handleClose={() => setOpenFanSelectionPopUp(false)} setIndex={setIndex} />
    </form>
  )
}
